import React from 'react';
import { Car, Footprints, TreePine, AlertTriangle, Check } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
export function ApplicationGuideSection() {
  const applications = [{
    icon: Car,
    title: 'Driveways',
    priority: 'Traction + Scaling Resistance',
    description: 'Heavy loads, tire wear, and salt exposure mean durability comes first.',
    best: ['Broom Finish', 'Exposed Aggregate'],
    avoid: ['Smooth/Troweled', 'Unprotected Stamped on slopes']
  }, {
    icon: Footprints,
    title: 'Walkways & Steps',
    priority: 'Slip Resistance + Safe Edges',
    description: 'Foot traffic, snow boots, and elderly/kids safety are the main concerns.',
    best: ['Broom Finish', 'Exposed Aggregate'],
    avoid: ['Smooth on steps', 'Stamped without texture additive']
  }, {
    icon: TreePine,
    title: 'Patios',
    priority: 'Comfort + Appearance',
    description: 'Bare feet, dining furniture, and entertaining mean aesthetics matter more.',
    best: ['Exposed Aggregate', 'Stamped', 'Salt Finish'],
    avoid: ['Rough Broom (less decorative)']
  }];
  return <section className="py-16 bg-slate-50 md:py-24" data-id="element-73">
      <div className="container mx-auto px-4 md:px-6" data-id="element-74">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-75">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-76">
            What Matters by Application
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-77">
            The right finish depends on how you use the space.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-78">
          {applications.map((app, index) => <Card key={index} className="border-slate-200 hover:border-primary/30 transition-colors" data-id="element-79">
              <CardHeader data-id="element-80">
                <div className="w-12 h-12 rounded-lg bg-white border border-slate-200 flex items-center justify-center mb-4 text-primary shadow-sm" data-id="element-81">
                  <app.icon className="h-6 w-6" data-id="element-82" />
                </div>
                <CardTitle className="text-xl" data-id="element-83">{app.title}</CardTitle>
                <div className="inline-block bg-primary/10 px-2 py-1 rounded text-xs font-bold text-primary mt-2" data-id="element-84">
                  Priority: {app.priority}
                </div>
              </CardHeader>
              <CardContent data-id="element-85">
                <p className="text-slate-600 mb-6 text-sm" data-id="element-86">{app.description}</p>

                <div className="space-y-4" data-id="element-87">
                  <div data-id="element-88">
                    <h4 className="text-sm font-bold text-green-700 mb-2 flex items-center gap-2" data-id="element-89">
                      <Check className="h-4 w-4" data-id="element-90" /> Best Finishes:
                    </h4>
                    <ul className="space-y-1" data-id="element-91">
                      {app.best.map((item, i) => <li key={i} className="text-sm text-slate-600 pl-6 relative" data-id="element-92">
                          <span className="absolute left-2 top-2 w-1 h-1 rounded-full bg-slate-400" data-id="element-93"></span>
                          {item}
                        </li>)}
                    </ul>
                  </div>

                  <div data-id="element-94">
                    <h4 className="text-sm font-bold text-red-700 mb-2 flex items-center gap-2" data-id="element-95">
                      <AlertTriangle className="h-4 w-4" data-id="element-96" /> Avoid:
                    </h4>
                    <ul className="space-y-1" data-id="element-97">
                      {app.avoid.map((item, i) => <li key={i} className="text-sm text-slate-600 pl-6 relative" data-id="element-98">
                          <span className="absolute left-2 top-2 w-1 h-1 rounded-full bg-slate-400" data-id="element-99"></span>
                          {item}
                        </li>)}
                    </ul>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}